import HorizontalScroll from "@/Components/HorizontalScroll";

interface ConditionalScrollProps {
  children: React.ReactNode;
  unitWidthPx: number;
  scrollThreshold: number;
  numberOfItems: number;
}

export const ConditionalScroll = ({
  children,
  unitWidthPx,
  scrollThreshold,
  numberOfItems,
}: ConditionalScrollProps) => {
  const scrollable = numberOfItems > scrollThreshold;
  if (scrollable) {
    const containerWidth = unitWidthPx * numberOfItems;
    return <HorizontalScroll minWidth={containerWidth}>{children}</HorizontalScroll>;
  }

  return <>{children}</>;
};

export default ConditionalScroll;
